// Elenco degli immobili in portfolio.
// Aggiungere qui un nuovo oggetto per aggiungere un immobile alla galleria.
export const properties = [
  {
    id: "tonale-milano",
    address: "Via Tonale",
    area: "Milano",
    type: "Affitto transitorio",
    typeKey: "transitorio",
    duration: "12 mesi",
    size: "50 mq",
    price: "1.300",
    priceSuffix: "€ / mese + spese",
    status: "Convertito",
    note: "Caso reale di conversione: da affitto breve a transitorio.",
    images: [
      "https://customer-assets.emergentagent.com/job_transitorio-milano/artifacts/9ftcujlm_259A1689-HDR.jpg",
      "https://customer-assets.emergentagent.com/job_transitorio-milano/artifacts/oqogr4o0_259A1868-HDR.jpg",
      "https://customer-assets.emergentagent.com/job_transitorio-milano/artifacts/5thq0gxo_259A1765-HDR.jpg",
    ],
  },
  {
    id: "pontaccio-milano",
    address: "Via Pontaccio",
    area: "Milano · Brera",
    type: "Affitto transitorio",
    typeKey: "transitorio",
    duration: "12 mesi",
    size: "45 mq",
    price: "1.600",
    priceSuffix: "€ / mese + spese",
    status: "Convertito",
    note: "Caso reale di conversione: da affitto breve a transitorio.",
    images: [
      "https://customer-assets.emergentagent.com/job_transitorio-milano/artifacts/imt2wku2_R5__4689-Edit%20%282%29.jpg",
      "https://customer-assets.emergentagent.com/job_transitorio-milano/artifacts/q7mq5qwg_R5__4613-Edit%20%282%29.jpg",
      "https://customer-assets.emergentagent.com/job_transitorio-milano/artifacts/4ftx6cci_R5__4679-Edit%20%282%29.jpg",
    ],
  },
  {
    id: "gb-grassi-milano",
    address: "Via Giovanni Battista Grassi",
    area: "Milano",
    type: "Affitto transitorio",
    typeKey: "transitorio",
    duration: "12 mesi",
    size: "50 mq",
    price: "800",
    priceSuffix: "€ / mese + spese",
    status: "Convertito",
    note: "Caso reale di conversione: da affitto breve a transitorio.",
    images: [
      "https://customer-assets.emergentagent.com/job_transitorio-milano/artifacts/jcwflmoz_IMG_9475-Enhanced-NR-Edit%20%283%29.jpg",
      "https://customer-assets.emergentagent.com/job_transitorio-milano/artifacts/e3f96cct_IMG_9537-Enhanced-NR-Edit%20%283%29.jpg",
      "https://customer-assets.emergentagent.com/job_transitorio-milano/artifacts/7ssrulq7_IMG_9509-Enhanced-NR%20%283%29.jpg",
    ],
  },
  {
    id: "viale-marche-milano",
    address: "Viale Marche",
    area: "Milano",
    type: "Affitto transitorio",
    typeKey: "transitorio",
    duration: "12 mesi",
    size: "55 mq",
    price: "1.200",
    priceSuffix: "€ / mese + spese",
    status: "Convertito",
    note: "Caso reale di conversione: da affitto breve a transitorio. Margini più alti, zero commissioni OTA.",
    images: [
      "https://customer-assets.emergentagent.com/job_transitorio-milano/artifacts/whwffh2m_1E6A0091-Edit-Edit.jpg",
      "https://customer-assets.emergentagent.com/job_transitorio-milano/artifacts/uer04d69_1E6A0165-Edit-Edit.jpg",
      "https://customer-assets.emergentagent.com/job_transitorio-milano/artifacts/jvaodeht_1E6A0152-Edit.jpg",
    ],
  },
  {
    id: "piazza-firenze-milano",
    address: "Piazza Firenze",
    area: "Milano",
    type: "Affitto breve",
    typeKey: "breve",
    duration: null,
    size: "52 mq",
    price: "30.000",
    priceSuffix: "€ / anno lordi",
    priceLabel: "Rendita",
    status: "In conversione",
    note: "Attualmente in affitto breve. Prossima conversione ad affitto transitorio a ottobre 2026.",
    images: [
      "https://customer-assets.emergentagent.com/job_transitorio-milano/artifacts/zsub51me_R5__8834-Edit-Edit.jpg",
      "https://customer-assets.emergentagent.com/job_transitorio-milano/artifacts/ib9ww5pa_R5__8911-Edit.jpg",
      "https://customer-assets.emergentagent.com/job_transitorio-milano/artifacts/mtq6qr93_Untitled-1-Edit.jpg",
    ],
  },
  {
    id: "san-basilio-milano",
    address: "Via Privata San Basilio",
    area: "Milano",
    type: "Affitto breve",
    typeKey: "breve",
    duration: null,
    size: "55 mq",
    price: "30.000",
    priceSuffix: "€ / anno lordi",
    priceLabel: "Rendita",
    status: "In conversione",
    note: "Attualmente in affitto breve. Prossima conversione ad affitto 3+2 da novembre 2026.",
    images: [
      "https://customer-assets.emergentagent.com/job_transitorio-milano/artifacts/u81fm3n7_WhatsApp%20Image%202024-11-29%20at%2013.22.42%20%281%29.jpeg",
      "https://customer-assets.emergentagent.com/job_transitorio-milano/artifacts/zgt15pro_WhatsApp%20Image%202024-11-29%20at%2013.22.42%20%2816%29.jpeg",
      "https://customer-assets.emergentagent.com/job_transitorio-milano/artifacts/sznpbf42_WhatsApp%20Image%202024-11-29%20at%2013.22.42%20%2840%29.jpeg",
    ],
  },
  {
    id: "carlo-maggi-milano",
    address: "Via Carlo Maggi",
    area: "Milano",
    type: "Affitto breve",
    typeKey: "breve",
    duration: null,
    size: "45 mq",
    price: "45.000",
    priceSuffix: "€ / anno lordi",
    priceLabel: "Rendita",
    status: "Locato",
    images: [
      "https://customer-assets.emergentagent.com/job_transitorio-milano/artifacts/x4xr7prl_1E6A9938-Edit.jpg",
      "https://customer-assets.emergentagent.com/job_transitorio-milano/artifacts/mg81f45v_1E6A9918-Edit.jpg",
      "https://customer-assets.emergentagent.com/job_transitorio-milano/artifacts/8bgpfi2d_1E6A9895-Edit.jpg",
    ],
  },
  {
    id: "del-torchio-milano",
    address: "Via del Torchio",
    area: "Milano · Centro",
    type: "Affitto breve",
    typeKey: "breve",
    duration: null,
    size: "70 mq",
    price: "64.000",
    priceSuffix: "€ / anno lordi",
    priceLabel: "Rendita",
    status: "Locato",
    images: [
      "https://customer-assets.emergentagent.com/job_transitorio-milano/artifacts/tjiub61h_Via%20del%20Torchio_10.jpg",
      "https://customer-assets.emergentagent.com/job_transitorio-milano/artifacts/3r3em0qy_Via%20del%20Torchio_17.jpg",
      "https://customer-assets.emergentagent.com/job_transitorio-milano/artifacts/f32df06v_Via%20del%20Torchio_36.jpg",
    ],
  },
  {
    id: "ferrucci-milano",
    address: "Via Ferrucci",
    area: "Milano",
    type: "Affitto breve",
    typeKey: "breve",
    duration: null,
    size: "60 mq",
    price: "53.000",
    priceSuffix: "€ / anno lordi",
    priceLabel: "Rendita",
    status: "Locato",
    images: [
      "https://customer-assets.emergentagent.com/job_transitorio-milano/artifacts/uxptj2uq_259A0361-Enhanced-NR-Edit-Edit%20%281%29.jpg",
      "https://customer-assets.emergentagent.com/job_transitorio-milano/artifacts/6eqk559v_259A0397-Enhanced-NR-Edit%20%282%29.jpg",
      "https://customer-assets.emergentagent.com/job_transitorio-milano/artifacts/ib7ztuwq_259A0440-Enhanced-NR-Edit%20%281%29.jpg",
      "https://customer-assets.emergentagent.com/job_transitorio-milano/artifacts/bule8rhw_259A0421-Enhanced-NR-Edit%20%281%29.jpg",
    ],
  },
  {
    id: "lago-lecco",
    address: "Lago di Lecco",
    area: "Lombardia · Laghi",
    type: "Affitto breve",
    typeKey: "breve",
    duration: null,
    size: "70 mq",
    price: null,
    priceSuffix: null,
    status: "In partenza",
    note: "Inizio affitto breve a giugno 2026. Vista lago e montagna, target turismo internazionale.",
    images: [
      "https://customer-assets.emergentagent.com/job_transitorio-milano/artifacts/e4o83ngl_A7A02400-15.jpeg",
      "https://customer-assets.emergentagent.com/job_transitorio-milano/artifacts/j1ixv33v_A7A02385-1.jpg",
      "https://customer-assets.emergentagent.com/job_transitorio-milano/artifacts/dmulmxpp_A7A02396-11.jpg",
      "https://customer-assets.emergentagent.com/job_transitorio-milano/artifacts/4jsifx68_A7A02408-22.jpg",
      "https://customer-assets.emergentagent.com/job_transitorio-milano/artifacts/m2hwg3pg_A7A02419-32.jpg",
    ],
  },
  {
    id: "viale-marche-vendita",
    address: "Viale Marche",
    area: "Milano",
    type: "Vendita",
    typeKey: "vendita",
    duration: null,
    size: "40 mq",
    price: "210.000",
    priceSuffix: "€ prezzo di vendita",
    priceLabel: "Prezzo",
    status: "Venduto",
    note: "Venduto a prezzo pieno grazie a 4 anni di storico documentato di affitto breve: rendita certificata = valore di mercato superiore.",
    images: [
      "https://customer-assets.emergentagent.com/job_transitorio-milano/artifacts/bg62hecx_07%20%283%29.jpg",
      "https://customer-assets.emergentagent.com/job_transitorio-milano/artifacts/kzh6r7v4_08%20%283%29.jpg",
      "https://customer-assets.emergentagent.com/job_transitorio-milano/artifacts/uxzis54z_03%20%281%29.jpg",
    ],
  },
  {
    id: "molino-delle-armi-milano",
    address: "Via Molino delle Armi",
    area: "Milano · Centro",
    type: "Affitto breve",
    typeKey: "breve",
    duration: null,
    size: "90 mq",
    price: "58.000",
    priceSuffix: "€ / anno lordi",
    priceLabel: "Rendita",
    status: "In vendita",
    note: "Attualmente in affitto breve. Prossima vendita a ottobre 2026, dopo il rifacimento del tetto.",
    images: [
      "https://customer-assets.emergentagent.com/job_transitorio-milano/artifacts/trobiw21_14.jpg",
      "https://customer-assets.emergentagent.com/job_transitorio-milano/artifacts/7vijsr5i_16c.JPG",
      "https://customer-assets.emergentagent.com/job_transitorio-milano/artifacts/qdepngoa_22a.JPG",
      "https://customer-assets.emergentagent.com/job_transitorio-milano/artifacts/bi8telqc_25.jpg",
    ],
  },
];
